import { connect } from 'react-redux';
import { onChange } from './events/onChange';
import { IApplicationState } from '../../../../../../../../types/types';
import { IDriveDocsImgsHOCProps } from './types';
import { DriveDocsImgs } from '../../components/DriveDocsImgs/DriveDocsImgs';
import { IDriveDocsImgsEvents, IDriveDocsImgsFields } from '../../components/DriveDocsImgs/types';
import { getCard } from '../../../../../../../../store/model/selectors/getCard';
import { Analyze } from '../../../../../../helpers/memoizeHelper';

// const analyze = new Analyze('DriveDocImgsHOC');

const mapStateToProps = (
    state: IApplicationState,
    { images, cardId }: IDriveDocsImgsHOCProps
): IDriveDocsImgsFields => {
    // analyze.start();
    const card = getCard(state, cardId);
    const props = {
        cardId,
        images,
        pinnedImageIndex: card.pinnedImageIndex || 0
    };
    // analyze.finish();
    return props;
};

const mapDispatchToProps = (
    dispatch: any,
    { cardId, onToggleLoadingImg, onHeightChange }: IDriveDocsImgsHOCProps
): IDriveDocsImgsEvents => {
    return {
        onChange: (idx) => dispatch(onChange(cardId, idx)),
        onHeightChange,
        onToggleLoadingImg,
    };
};

export const DriveDocImgsHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(DriveDocsImgs);

DriveDocImgsHOC.displayName = 'DriveDocImgsHOC';
